module.exports = __webpack_public_path__ + "static/media/Beach9.40cc0f49.jpg";